import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { StatusPill, type StatusTone } from './StatusPill';

// Policy-status badge for repo cards + repo detail.
// One reason to change: how we render policy status.

export type PolicyStatus = 'valid' | 'invalid' | 'missing' | 'unknown';

export type PolicyStatusBadgeProps = {
  readonly status: PolicyStatus;
};

const LABEL_KEY: Readonly<Record<PolicyStatus, string>> = {
  valid: 'policy_badge.valid',
  invalid: 'policy_badge.invalid',
  missing: 'policy_badge.missing',
  unknown: 'policy_badge.unknown',
};

const TONE: Readonly<Record<PolicyStatus, StatusTone>> = {
  valid: 'success',
  invalid: 'danger',
  missing: 'neutral',
  unknown: 'neutral',
};

export function PolicyStatusBadge(props: PolicyStatusBadgeProps): JSX.Element {
  return (
    <span data-status={props.status}>
      <StatusPill tone={TONE[props.status]}>{t(LABEL_KEY[props.status])}</StatusPill>
    </span>
  );
}
